// import {
//   CREATE_GIFT_CREATE_REQUEST,
//   CREATE_GIFT_CREATE_SUCCESS,
//   CREATE_GIFT_CREATE_FAIL,
//   FETCH_GIFT_LIST_REQUEST,
//   FETCH_GIFT_LIST_SUCCESS,
//   FETCH_GIFT_LIST_FAIL,
// } from "../actionTypes";

// const initialState = {
//   loading: false,
//   giftInfo: null,
//   error: null,
// };

// export const GiftReducer = (
//   state = { loading: false, gift: [], error: null },
//   action
// ) => {
//   switch (action.type) {
//     case CREATE_GIFT_CREATE_REQUEST:
//       return {
//         ...state,
//         loading: true,
//         error: null,
//       };
//     case CREATE_GIFT_CREATE_SUCCESS:
//       return {
//         ...state,
//         loading: false,
//         gift: action.payload, // Change from salesmanInfo to salesmen
//         error: null,
//       };
//     case CREATE_GIFT_CREATE_FAIL:
//       return {
//         ...state,
//         loading: false,
//         error: action.payload,
//       };

//     default:
//       return state;
//   }
// };

// export default GiftReducer;
// ...existing code...
import GiftList from "../../Pages/Gifts/GiftsList";
import {
  CREATE_GIFT_CREATE_REQUEST,
  CREATE_GIFT_CREATE_SUCCESS,
  CREATE_GIFT_CREATE_FAIL,
  FETCH_GIFT_LIST_REQUEST,
  FETCH_GIFT_LIST_SUCCESS,
  FETCH_GIFT_LIST_FAIL,
  CREATE_GIFT_MASTER_CREATE_REQUEST,
  CREATE_GIFT_MASTER_CREATE_SUCCESS,
  CREATE_GIFT_MASTER_CREATE_FAIL,
  FETCH_GIFT_MASTER_REQUEST,
  FETCH_GIFT_MASTER_SUCCESS,
  FETCH_GIFT_MASTER_FAIL,
  FETCH_OFFER_SCHEME_REQUEST,
  FETCH_OFFER_SCHEME_SUCCESS,
  FETCH_OFFER_SCHEME_FAIL,
  FETCH_GIFTS_BY_SCHEME_REQUEST,
  FETCH_GIFTS_BY_SCHEME_SUCCESS,
  FETCH_GIFTS_BY_SCHEME_FAIL,
  UPDATE_GIFT_MASTER_REQUEST,
  UPDATE_GIFT_MASTER_SUCCESS,
  UPDATE_GIFT_MASTER_FAILED,
  ADD_GIFT_TO_SCHEME_REQUEST,
  ADD_GIFT_TO_SCHEME_SUCCESS,
  ADD_GIFT_TO_SCHEME_FAIL,
} from "../actionTypes";

const initialState = {
  loading: false,
  gifts: [],
  gift: null,
  error: null,
  creategift: null,
  GiftList: null,
  offerScheme: null,
};

export const GiftReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_GIFT_CREATE_REQUEST:
    case FETCH_GIFT_LIST_REQUEST:
    case CREATE_GIFT_MASTER_CREATE_REQUEST:
    case FETCH_GIFT_MASTER_REQUEST:
    case FETCH_OFFER_SCHEME_REQUEST:
    case FETCH_GIFTS_BY_SCHEME_REQUEST:
    case UPDATE_GIFT_MASTER_REQUEST:
    case ADD_GIFT_TO_SCHEME_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CREATE_GIFT_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        gift: action.payload,
        error: null,
      };

    case FETCH_GIFT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        gifts: action.payload,
        error: null,
      };
    case CREATE_GIFT_MASTER_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        creategift: action.payload,
        error: null,
      };
    case UPDATE_GIFT_MASTER_SUCCESS:
    case ADD_GIFT_TO_SCHEME_SUCCESS:
      return {
        ...state,
        loading: false,
        creategift: action.payload,
        error: null,
      };

    case FETCH_GIFT_MASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        GiftList: action.payload,
        error: null,
      };

    case FETCH_OFFER_SCHEME_SUCCESS:
      return {
        ...state,
        loading: false,
        offerScheme: action.payload,
        error: null,
      };
    case FETCH_GIFTS_BY_SCHEME_SUCCESS:
      return {
        ...state,
        loading: false,
        gifts: action.payload,
        error: null,
      };

    case CREATE_GIFT_CREATE_FAIL:
    case FETCH_GIFT_LIST_FAIL:
    case CREATE_GIFT_MASTER_CREATE_FAIL:
    case FETCH_GIFT_MASTER_FAIL:
    case FETCH_OFFER_SCHEME_FAIL:
    case FETCH_GIFTS_BY_SCHEME_FAIL:
    case UPDATE_GIFT_MASTER_FAILED:
    case ADD_GIFT_TO_SCHEME_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default GiftReducer;
